import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from "axios";
axios.defaults.headers.common = { "X-Requested-With": "XMLHttpRequest" };

export const useCartStore = defineStore('cart', () => {
  const completeOrderSnap = ref([]);
  const products = ref([]);
  const total = ref([]);

  ////////////////////////////////////////////////////////////////// Get data
  const get = () => {
    return axios.get(window.Laravel.shop.cart.get)
      .then(response => {
        products.value = response.data.items;
        total.value = response.data.total;
        completeOrderSnap.value = response.data;
      })
      .catch(error => {
        // console.error(error);
      });
  }

  // --- Add a product
  const add = (product_id, variant_id, size = null) => {
    const payload = {
      product_id,
      variant_id
    };
    if (size !== null) payload.size = size;

    // since we return the promise, the calling function can handle errors with .catch so we always return / throw error here
    return axios.post(window.Laravel.shop.cart.add, payload)
      .then(response => {
        products.value = response.data.cart.items;
        total.value = response.data.cart.total;
        return response;
      })
      .catch(error => {
        throw error;
      });
  };

  // --- Increase quantity (by 1 or any amount)
  const increase = (order_item_id, qty = 1) => {
    const url = window.Laravel.shop.cart.increase
      .replace('param_order_item_id', order_item_id)
      .replace('param_qty', qty);
    return axios.get(url)
      .then(response => {
        products.value = response.data.cart.items;
        total.value = response.data.cart.total;
        return response;
      })
      .catch(error => error);
  };

  // --- Decrease quantity (by 1 or any amount)
  const decrease = (order_item_id, qty = 1) => {
    const url = window.Laravel.shop.cart.decrease
      .replace('param_order_item_id', order_item_id)
      .replace('param_qty', qty);
    return axios.get(url)
      .then(response => {
        products.value = response.data.cart.items;
        total.value = response.data.cart.total;
        return response;
      })
      .catch(error => error);
  };

  // --- Remove product (set qty to 0)
  // (if your backend removes the item when quantity is set to 0 via decrease)
  const remove = (order_item_id) => {
    // Set quantity to a large number to guarantee removal
    // Or add a dedicated remove endpoint if you have one!
    return decrease(order_item_id, 0);
  };

  ////////////////////// Export store
  return {
    completeOrderSnap,
    products,
    total,
    get,
    add,
    increase,
    decrease,
    remove
  };
});